module.exports = __webpack_public_path__ + "static/media/ex1_3_4.60fac049.mp3";